<template>
	<div class="home">
		<div class="home__content">
			<img class="home__bg zIndex-1" :src='homeList.length !== 0 ? homeList[choseItem].backgroundImage : "" ' />
			<div class="home__mask zIndex-1"></div>
			<div class="home__swiper">
				<div class="change__prev change__btn scal" @click="prev">PREV</div>
				<div class="change__line"></div>
				<div class="circle_process">
					<div class="wrapper right">
						<div class="circle rightcircle" ref='rightcircle'></div>
					</div>

					<div class="wrapper left">
						<div class="circle leftcircle" ref='leftcircle'></div>
					</div>
					<el-carousel
						ref='homeSwiper'
						indicator-position='none'
						:interval='time'
						:setActiveItem="setActiveItem"
						@change='changeFn'
						arrow='never'
						>
						<el-carousel-item v-for="(item,index) in homeList" :key="index" arrow="always">
							<div class="swiper__list__img" v-if="item.type === 'image'">
								<img src='https://static.zc0901.com/imola-dci-web-icon-new-1.png' />
								<div>{{item.content}}</div>
							</div>
							<div class="swiper__list__text" v-else>
								<div>{{item.title}}</div>
								<div></div>
								<div>{{item.content}}</div>
								<img @click="viewCase(item.link)" src='https://static.zc0901.com/dci-web-home-view-case-ne.png' />
							</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="change__line"></div>
				<div class="change__next change__btn scal" @click="next">NEXT</div>
				
			</div>
			<div class="home__foot">
				<div v-for="(item,index) in 4" :key="index" class="home__foot__for">
					<div :class="choseItem === index ? 'home__foot__item_line_chose' : 'home__foot__item_line'"  ></div>
					<div :class="choseItem === index ? 'home__foot__item_title_chose' : 'home__foot__item_title'">0{{ item }}</div>
				</div>
			</div>
		</div>
		
		<foot></foot>
		<div class="home__advertisement">
			<div>
				<a href="http://www.lattoflex-cn.com/" target="view_window">智能床垫</a>
				<a href="http://www.point-link.com/" target="view_window">标签喷码机</a>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import foot from '../../components/foot/index'
import './index.scss'
export default {
	components: {
		foot
	},
	data() {
		return {
			time:6000,
			choseItem:0,
			sections:[
				{ label: 'Red section', value: 0,},
			],
			timer:null,
			resetAnimation:false,
		};
	},
	computed: {
		...mapState('common',['homeList'])
	},
	async created() {
		await this.HOMELIST()
	},
	mounted() {
		
	},
	methods: {
		...mapActions('common',['HOMELIST']),
		changeFn(now,old){
			this.choseItem = now
			this.$refs.rightcircle.classList.remove("rightcircle")
			this.$refs.leftcircle.classList.remove("leftcircle")
			// this.$refs.rightcircle.offsetWidth = this.$refs.rightcircle.offsetWidth;
			// this.$refs.leftcircle.offsetWidth = this.$refs.leftcircle.offsetWidth;
			setTimeout(()=>{
				this.$refs.rightcircle.classList.add("rightcircle")
				this.$refs.leftcircle.classList.add("leftcircle")
			},100)
		},
		prev(){
			this.$refs.homeSwiper.prev()
		},
		next(){
			this.$refs.homeSwiper.next()
		},
		setActiveItem(){

		},
		viewCase(link){
			this.$router.push({
				path: `../seriesDetail`,
				query: {
					id: link === null ? 1 : link
				}
			})
		},

	}
};
</script>
<style lang="scss" scoped>
.el-carousel {
	width: 680px;
	height: 680px;
	margin: 0 auto;
	border-radius: 50%;
	min-width: 680px;
	box-sizing: border-box;
	overflow: hidden;
}
.el-carousel__item{
	width:680px;
	height:680px;
	border-radius: 50%;
	box-sizing: border-box;
}

</style>
